import { SLOTS_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

import { IOverBookingPermitProps, IOverBookingPermitResponse } from "@/api_framework/api_modals/Bookings";
import AxiosCurlirize from "axios-curlirize";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useOverBookingPirmitAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (filterParams: IOverBookingPermitProps) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios

          .post(SLOTS_APIS?.CREATE_OVER_BOOKING?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IOverBookingPermitResponse>) => {
            if (res.data.status === true) {
              //
              toast.success("Over Booking Access Done.");
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            if (e.status === 400 || e.code === "ERR_BAD_REQUEST") {
              toast.error("Error while creating overbooking");
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
